import React from 'react';
import {
  Filter,
  Users,
  FileText,
  Server,
  Settings,
  Calendar,
  Layers,
} from 'lucide-react';

const MobileBottomBar = ({ rolUsuario, onFilterToggle, onNavigation, onToggleTemplate }) => {
  const commonButtonClass =
    'group inline-flex flex-col items-center justify-center px-1 hover:bg-gray-50 dark:hover:bg-secondary-dark flex-1 max-w-[70px]';
  const iconClass = 'w-5 h-5 text-white mb-0.5';
  const spanClass =
    'text-[10px] text-gray-500 group-hover:text-blue-600 dark:text-gray-400 dark:group-hover:text-blue-500 truncate w-full text-center';

  return (
    <div className="border-primary-light bg-primary-dark dark:bg-secondary-dark fixed bottom-0 left-0 z-50 h-16 w-full border-t sm:hidden">
      <div className="mx-auto flex h-full max-w-lg items-center justify-around font-medium px-2">
        <button
          type="button"
          onClick={onFilterToggle}
          className={commonButtonClass}
        >
          <Filter className={iconClass} />
          <span className={spanClass}>Filtros</span>
        </button>

        {rolUsuario === 'admin' && (
          <>
            <button
              type="button"
              onClick={() => onNavigation('/configuration/users')}
              className={commonButtonClass}
            >
              <Users className={iconClass} />
              <span className={spanClass}>Usuarios</span>
            </button>
            <button
              type="button"
              onClick={() => onNavigation('/configuration/logs')}
              className={commonButtonClass}
            >
              <FileText className={iconClass} />
              <span className={spanClass}>Logs</span>
            </button>
            <button
              type="button"
              onClick={() => onNavigation('/configuration/server')}
              className={commonButtonClass}
            >
              <Server className={iconClass} />
              <span className={spanClass}>Server</span>
            </button>
            <button
              className={commonButtonClass}
              onClick={() => onNavigation('/configuration')}
            >
              <Settings className={iconClass} />
              <span className={spanClass}>Config</span>
            </button>
            <button
              hidden
              className={commonButtonClass + ' hidden'}
              onClick={() => onNavigation('/appointments')}
            >
              <Calendar className={iconClass} />
              <span className={spanClass}>Agenda</span>
            </button>
            <button
              type="button"
              onClick={onToggleTemplate}
              className={commonButtonClass + ' hidden'}
            >
              <Layers className={iconClass} />
              <span className={spanClass}>Template</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileBottomBar;
